import { CompanyDocumentShowHeaderComponent } from './company-document-show-header/company-document-show-header.component';
import { DocumentDetailsComponent } from './document-details/document-details.component';
import { DocumentFoldersSidebarComponent } from './document-folders-sidebar/document-folders-sidebar.component';
import { DocumentTagMenuComponent } from './document-tag-menu/document-tag-menu.component';
import { MultiSignerStatusComponent } from './multi-signer-status/multi-signer-status.component';

const StandaloneComponents = [
    CompanyDocumentShowHeaderComponent,
    DocumentDetailsComponent,
    DocumentFoldersSidebarComponent,
    DocumentTagMenuComponent,
    MultiSignerStatusComponent,
];

export {
    CompanyDocumentShowHeaderComponent,
    DocumentDetailsComponent,
    DocumentFoldersSidebarComponent,
    DocumentTagMenuComponent,
    MultiSignerStatusComponent,
    StandaloneComponents,
};
